// Simple admin sub-nav. Admin is utilitarian/official — plain tabs, no zine flourish.
// (The Public/Admin switch lives in the header now.)

import { Link, useLocation } from "react-router-dom";

const TABS = [
  { to: "/admin", label: "Posts", match: (p: string) => p === "/admin" || p.startsWith("/admin/posts") },
  { to: "/admin/friends", label: "Friends", match: (p: string) => p.startsWith("/admin/friends") },
];

export function AdminNav() {
  const { pathname } = useLocation();

  return (
    <nav className="mb-6 flex items-center border-b border-ink/15">
      <div className="flex gap-1">
        {TABS.map((t) => {
          const active = t.match(pathname);
          return (
            <Link
              key={t.to}
              to={t.to}
              className={
                "-mb-px border-b-2 px-4 py-2 text-sm font-semibold " +
                (active
                  ? "border-ink text-ink"
                  : "border-transparent text-ink-muted hover:text-ink")
              }
            >
              {t.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
